import { useState, useEffect } from "react";
import { Fab, Fade } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector("footer");
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        setIsVisible(footerRect.top <= window.innerHeight);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Fade in={isVisible}>
      <Fab
        onClick={scrollToTop}
        size="small"
        aria-label="scroll back to top"
        sx={{
          bgcolor: "#ef4056",
          color: "#fff",
          minHeight: 36,
          width: 36,
          height: 36,
          boxShadow: "0px 2px 8px rgba(239, 64, 86, 0.3)",
          "&:hover": { bgcolor: "#d73247" },
          transition: "background-color 0.2s",
        }}
      >
        <KeyboardArrowUpIcon fontSize="small" />
      </Fab>
    </Fade>
  );
}